import React, { useState, useEffect } from "react";
import Button from "./button";

const PHRASES = [
  "pay for itself",
  "pull its weight",
  "earn its keep",
];

const TYPE_MS = 80;
const PAUSE_MS = 2200;

const Header = () => {
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  const phrase = PHRASES[phraseIndex];
  const displayed = phrase.slice(0, charIndex);

  const scrollToFeaturedWork = () => {
    const el = document.getElementById("featured-work");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    window.location.href = "/work";
  };

  useEffect(() => {
    if (charIndex < phrase.length) {
      const t = setTimeout(() => setCharIndex((c) => c + 1), TYPE_MS);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => {
      setPhraseIndex((i) => (i + 1) % PHRASES.length);
      setCharIndex(0);
    }, PAUSE_MS);
    return () => clearTimeout(t);
  }, [charIndex, phrase.length]);

  return (
    <div className="header-body container">
      <div>
        <h1 className="hero-title">
          Your next website should{" "}<br/>
          <span className="hero-title__accent">
            {displayed}
          </span>
          .
        </h1>
        <p className="hero-lead m-auto pb-3">
          We help growing businesses show up with a brand & website that feels
          cohesive, modern, and intentional.
        </p>
        <Button onClick={scrollToFeaturedWork}>See our work</Button>
      </div>
    </div>
  );
};

export default Header;
